import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchProjects, fetchTechnologies, fetchFormations, fetchExperiences } from '../../services/api';
import Loader from '../../components/admin/ui/Loader';
import ImagePreview from '../../components/admin/ui/ImagePreview';

function AdminDashboardPage() {
  const [projects, setProjects] = useState(null);
  const [stats, setStats] = useState(null);

  useEffect(() => {
    Promise.all([fetchProjects(), fetchTechnologies(), fetchFormations(), fetchExperiences()]).then(
      ([projectsData, technologies, formations, experiences]) => {
        const list = projectsData || [];
        const principalCount = list.filter((p) => p.category !== 'lab').length;
        const labCount = list.filter((p) => p.category === 'lab').length;
        setProjects(list);
        setStats({
          principalCount,
          labCount,
          categoriesCount: technologies?.categories?.length ?? 0,
          technologiesCount: technologies?.items?.length ?? 0,
          formationsCount: (formations || []).length,
          experiencesCount: (experiences || []).length
        });
      }
    );
  }, []);

  if (!stats) return <Loader label="Chargement du tableau de bord..." />;

  const cards = [
    { to: '/admin-bj/projets', label: 'Projets principaux', value: stats.principalCount },
    { to: '/admin-bj/projets', label: 'Projets Lab / IA', value: stats.labCount },
    { to: '/admin-bj/technologies', label: 'Technologies', value: stats.technologiesCount, sub: `${stats.categoriesCount} catégories` },
    { to: '/admin-bj/formations', label: 'Formations', value: stats.formationsCount },
    { to: '/admin-bj/experiences', label: 'Expériences pro', value: stats.experiencesCount },
    { to: '/admin-bj/textes', label: 'Textes du site', value: 'FR / EN' }
  ];

  const recentProjects = projects.slice(0, 3);

  return (
    <section className="admin-section">
      <h2>Tableau de bord</h2>
      <div className="admin-dashboard-grid">
        {cards.map((card) => (
          <Link key={card.label} to={card.to} className="admin-dashboard-card">
            <span className="admin-dashboard-value">{card.value}</span>
            <span className="admin-dashboard-label">{card.label}</span>
            {card.sub && <span className="admin-dashboard-sub">{card.sub}</span>}
          </Link>
        ))}
      </div>

      <div className="admin-dashboard-panels">
        <div className="admin-panel">
          <h3>Projets récents</h3>
          {recentProjects.map((project) => (
            <div className="admin-recent-item" key={project.id}>
              <div className="admin-recent-thumb">
                <ImagePreview src={project.logo} size={28} />
              </div>
              {project.nom?.fr || project.nom?.en}
              <span className="admin-muted">{project.category === 'lab' ? 'lab' : 'principal'}</span>
            </div>
          ))}
        </div>
        <div className="admin-panel">
          <h3>Actions rapides</h3>
          <div className="admin-quick-row">
            <Link className="admin-quick-link" to="/admin-bj/projets">
              + Ajouter un projet <span className="admin-muted">→</span>
            </Link>
            <Link className="admin-quick-link" to="/admin-bj/experiences">
              + Ajouter une expérience <span className="admin-muted">→</span>
            </Link>
            <Link className="admin-quick-link" to="/admin-bj/textes">
              Éditer les textes du site <span className="admin-muted">→</span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AdminDashboardPage;
